import { render, staticRenderFns } from "./InputItemReceipt.vue?vue&type=template&id=610b5766&scoped=true"
import script from "./InputItemReceipt.vue?vue&type=script&lang=js"
export * from "./InputItemReceipt.vue?vue&type=script&lang=js"
import style0 from "./InputItemReceipt.vue?vue&type=style&index=0&id=610b5766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610b5766",
  null
  
)

export default component.exports